<template>
    <div v-if="subsectionStructure.columns" class="subsection_table_holder">

        <div class="subsection_table_tools" style="margin-bottom: 20px;">
            <div class="table_style">
                <input type="checkbox" id="united_measures_table_style" v-model="filter_options">
                <label for="united_measures_table_style" class="pointer">Možnost filtriranja</label>
            </div>

            <div v-if="hasActiveColumnFilters" class="filter_status">
                <span>Prikazano {{ filteredRowKeys.length }} od {{ totalRowCount }} vrstic</span>
                <div class="as_link icon" title="Počisti filtre" @click="clearColumnFilters">
                    <font-awesome-icon :icon="['fas', 'filter-circle-xmark']" />
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="subsection_table_table" :class="{alternative: table_style}">

            <!-- Table header row -->
            <div class="row header">
                <!-- Table columns -->
                <div class="column column_header" v-for="(column, column_key) in subsectionStructure.columns" :key="column_key">

                    <span class="text">
                        {{ column.name }}
                    </span>

                    <span class="description">
                        {{ column.description }}
                    </span>

                </div>
            </div>

            <!-- Table filter row -->
            <div class="row filter" v-show="filter_options">
                <div class="column united_measurements_column"
                    v-for="(column, column_key) in subsectionStructure.columns" :key="'filter-' + column_key">
                    <input type="text" class="column_filter_input"
                        :value="columnFilters[column_key] || ''"
                        @input="setColumnFilter(column_key, $event.target.value)"
                        placeholder="Filtriraj" title="Filtriraj vrstice" />
                </div>
            </div>

            <!-- Table data rows -->
            <div class="row united_measurements_row data" v-for="row_key in filteredRowKeys" :key="row_key">
                <!-- Table columns -->
                <div class="column united_measurements_column" v-for="(column, column_key) in subsectionStructure.columns" :key="column_key">
                    <div v-if="column.type === undefined">
                        <div>
                            <span>{{ subsectionStructure.data[row_key][column_key] }}</span>
                        </div>
                    </div>

                    <div v-if="column.type == 1">
                        <textarea rows="1" :value="subsectionStructure.data[row_key][column_key]" disabled>
                        </textarea>
                    </div>

                    <div v-if="column.type == 2">
                        <input type="text" class="input_number" :value="subsectionStructure.data[row_key][column_key]" disabled>
                    </div>

                    <div v-if="column.type == 3">
                        <select :value="subsectionStructure.data[row_key][column_key]" disabled>
                            <option>/</option>
                            <option>DA</option>
                            <option>NE</option>
                        </select>
                    </div>

                    <div v-if="column.type == 4">
                        <textarea rows="4" :value="subsectionStructure.data[row_key][column_key]" disabled></textarea>
                    </div>

                    <div v-if="column.type == 5">
                        <div v-if="!subsectionStructure.data[row_key][column_key]">
                            Ni priponke
                        </div>

                        <div v-if="subsectionStructure.data[row_key][column_key] !== undefined && subsectionStructure.data[row_key][column_key] !== ''">
                            <div class="as_link icon left_margin floatLeft" title="Shrani priponko">
                                <a v-bind:href="subsectionStructure.data[row_key][column_key].file_url" target="_blank"><font-awesome-icon :icon="['fas', 'download']" />{{ subsectionStructure.data[row_key][column_key].name }}</a>
                            </div>
                        </div>
                    </div>

                    <div v-if="column.type == 6 || column.type == 8">
                        <div>
                            <span>{{ subsectionStructure.data[row_key][column_key] }}</span>
                        </div>
                    </div>

                    <!-- Izvorno leto vrstice -->
                    <div v-if="column.type == 7">
                        <div>
                            <span> {{ subsectionStructure.data[row_key][column_key] }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
	import { mapActions } from 'vuex';
	
	export default {
		name: 'SectionsDetailTableUnitedMeasures',
		components: {

        },
        data: function() {
			return {
                table_style: false,
                filter_options: false,
                columnFilters: {},
			}
        },
        watch: {
            active_subsection_id() {
                this.columnFilters = {};
            },
            filter_options(value) {
                if (!value) {
                    this.clearColumnFilters();
                }
            },
        },
        props: {
            deadline_not_closed: {
                type: Boolean,
                default: false
            }
        },
        computed: {

			// Selected subsection object with structure (table columns, input types...)
			subsectionStructure(){
                let subsectionStructure = this.$store.getters.subsections_data[this.active_subsection_id];
                return subsectionStructure ? subsectionStructure : {};
            },

            active_subsection_id(){
                return this.$store.getters.active_subsection_id;
            },

            section_level(){
                let section_level = this.$store.getters.section_level;
                return section_level;
            },

            totalRowCount() {
                return Object.keys(this.subsectionStructure.data || {}).length;
            },

            hasActiveColumnFilters() {
                return Object.values(this.columnFilters).some(
                    (value) => (value || '').trim() !== ''
                );
            },

            filteredRowKeys() {
                const rows = this.subsectionStructure.data;
                if (!rows) return [];

                const columns = this.subsectionStructure.columns;
                if (!columns || !Object.keys(columns).length) {
                    return Object.keys(rows);
                }

                return Object.keys(rows).filter((rowKey) =>
                    Object.entries(columns).every(([columnKey, column]) => {
                        const query = (this.columnFilters[columnKey] || '').trim().toLowerCase();
                        if (!query) return true;
                        return this.getCellFilterText(rowKey, columnKey, column).toLowerCase().includes(query);
                    })
                );
            },
		}, 
        methods: { 		
            ...mapActions([
				'hideModal',
                'showModal',
            ]),

            setColumnFilter(columnKey, value) {
                this.columnFilters = { ...this.columnFilters, [columnKey]: value };
            },

            clearColumnFilters() {
                this.columnFilters = {};
            },

            getCellFilterText(rowKey, columnKey, column) {
                const raw = this.subsectionStructure.data?.[rowKey]?.[columnKey];

                if (column.type == 5) {
                    return raw?.name ?? '';
                }

                return raw == null ? '' : String(raw);
            },

            // Get column type text
			columnTypeText(type){

                let text = '';
                if(type == 1)
                    text = 'Besedilo';
                else if(type == 2)
                    text = 'Število';
                else if(type == 3)
                    text = 'Da / Ne';
                else if(type == 4)
                    text = 'Datum';
                else if(type == 5)
                    text = 'Datoteka';
                else if(type == 6)
                    text = 'Roleta';
                else if (type == 8)
                    text = 'Roleta - drugo';
                else
                    text = 'Drugo';

                return text;
            },
        }
	}
</script>


<style lang="scss" scoped>
</style>
